<div class="ig-tabs" [ngClass]="{'ig-tabs--has-no-margin': noMargin}">
  <ul class="ig-tabs-controls" role="navigation">
    <li
      *ngFor="let tab of tabs"
      class="ig-tabs-controls__item"
      >
      <a
      class="ig-tabs-controls__link linkinbutton"
      [class.ig-tabs-controls__link--active]="tab.active"
      [class.ig-tabs-controls__link--disabled]="tab.disabled"
      [igTooltip]="tab.tabTooltip"
        (igA11yLink)="onSelectTab(tab)"
        >
          <span>{{ tab.tabTitle }}</span>
          <span class="ig-tabs-controls__link-icon" *ngIf="tab.tabIcon">
            <i [attr.class]="tab.tabIcon"></i>
          </span>

          <ig-count-label *ngIf="tab.badge?.value" [label]="tab.badgeValue"></ig-count-label>
        </a>
    </li>
  </ul>

  <ng-content></ng-content>
</div>
